import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  name: (<div className="text"><u>I</u>tems</div>),
  trigger: 'i',
  children: {
    'player_activate': {
      name: (<div className="text"><u>A</u>ctivate item</div>),
      trigger: 'a',
    },
    'player_charge': {
      name: (<div className="text"><u>C</u>harge active item</div>),
      trigger: 'c',
    },
    'player_discharge': {
      name: (<div className="text">Disc<u>h</u>arge active item</div>),
      trigger: 'h',
    },
    'player_consume': {
      name: (<div className="text">C<u>o</u>nsume trinket</div>),
      trigger: 'o',
    },
    'player_give': {
      name: (<div className="text"><u>G</u>ive item</div>),
      trigger: 'g',
    },
    'player_set_pocket': {
      name: (<div className="text">Set <u>p</u>ocket Active item</div>),
      trigger: 'p',
    },
    'player_drop_pocket': {
      name: (<div className="text"><u>D</u>rop pocket Card/Pill/Rune</div>),
      trigger: 'd',
    },
    'player_take': {
      name: (<div className="text"><u>T</u>ake item</div>),
      trigger: 't',
    },
    'player_take_all': {
      name: (<div className="text"><u>R</u>emove all items</div>),
      trigger: 'r',
    },
    'player_use': {
      name: (<div className="text"><u>U</u>se Pill/Card</div>),
      trigger: 'u',
    }
  }
}

/* ****************************************************************************************************************
 * Activate
 *
 * Activates the specified Active item. By default, a shadow element is created to be able to target the players
 * current active item. Activate can take an "active" input component, or a "Param" input component that is
 * set to be an "active" type.
 ******************************************************************************************************************/
Blockly.Blocks['player_activate'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_player_activate');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['active'])
      .appendField('Activate')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the specified Active item.');
    this.initSvg();
    this.showHelp = window.ShowEditorHelp(this,
      'Activate Item',
      <div>
        <p>
          Activate the specified active item.
        </p>
        <h3>Default State</h3>
        <svg width="340" height="34" viewBox="0 0 340 34" fill="none">
          <path class="blocklyPathDark" fill="#4d4d4d" d="M1 9a8 8 0 0 1 8-8h7l6 4h3l6-4h50.147v5c0 10-8-8-8 7.5s8-2.5 8 7.5v5H30.5l-6 4h-3l-6-4H9a8 8 0 0 1-8-8z" />
          <path class="blocklyPath" fill="#606060" d="M0 8a8 8 0 0 1 8-8h7l6 4h3l6-4h50.147v5c0 10-8-8-8 7.5s8-2.5 8 7.5v5H29.5l-6 4h-3l-6-4H8a8 8 0 0 1-8-8z" />
          <path class="blocklyPathLight" stroke="#909090" d="M.5 8a7.5 7.5 0 0 1 8-7.5H15l6 4h3l6-4h49.647m-4.5 18.8 3.68-2.1m-76.13 5.103A7.5 7.5 0 0 1 .5 17V8" />
          <g>
            <path class="blocklyPathDark" fill="#999" d="M82.147 1H278.94v25H82.147v-5c0-10-8 8-8-7.5s8 2.5 8-7.5z" />
            <path class="blocklyPath" fill="#999" d="M81.147 0H277.94v25H81.147v-5c0-10-8 8-8-7.5s8 2.5 8-7.5z" />
            <text class="blocklyText" y="13" transform="translate(91.147 5)">Players current active item.</text>
          </g>
          <text class="blocklyText" y="13" transform="translate(10 5)">Activate</text>
        </svg>
        <p>
          In the default state, the <strong>Activate Item</strong> action will activate the players current item in their Active Item slot.
        </p>
        <h3>Connectors</h3>
        <p>
          The <strong>Activate Item</strong> action can accept inputs that evaluate to an "Active Item"; these can be found in the <pre>Data</pre> menu.
        </p>
        <svg width="340" height="34" viewBox="21 50 340 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g>
            <path class="blocklyPathDark" fill="#4d4d4d" d="M22 61a8 8 0 0 1 8-8h7l6 4h3l6-4h50.147v5c0 10-8-8-8 7.5s8-2.5 8 7.5v5H51.5l-6 4h-3l-6-4H30a8 8 0 0 1-8-8z" />
            <path class="blocklyPath" fill="#606060" d="M21 60a8 8 0 0 1 8-8h7l6 4h3l6-4h50.147v5c0 10-8-8-8 7.5s8-2.5 8 7.5v5H50.5l-6 4h-3l-6-4H29a8 8 0 0 1-8-8z" />
            <path class="blocklyPathLight" stroke="#909090" d="M21.5 60a7.5 7.5 0 0 1 8-7.5H36l6 4h3l6-4h49.647m-4.5 18.8 3.68-2.1m-76.13 5.103A7.5 7.5 0 0 1 21.5 69v-9" />
            <text class="blocklyText" y="13" transform="translate(31 57)">Activate</text>
            <g>
              <path class="blocklyPathDark" fill="#000" d="M103.147 53H312.41v25H103.147v-5c0-10-8 8-8-7.5s8 2.5 8-7.5z" />
              <path class="blocklyPath" fill="#000" d="M102.147 52H311.41v25H102.147v-5c0-10-8 8-8-7.5s8 2.5 8-7.5z" />
              <path class="blocklyPathLight" stroke="#4d4d4d" d="M102.647 52.5H310.91m-208.263 24v-6m-7.36-.5q-1.52-5.5 0-11m7.36 1v-7.5" />
              <text class="blocklyText" y="13" transform="translate(112.147 57)">active item</text>
              <g class="blocklyEditableText" transform="translate(187.211 57)">
                <rect rx="4" ry="4" height="16" width="119.198" class="blocklyFieldRect blocklyDropdownRect" stroke="#4d4d4d" fill="#999" />
                <text class="blocklyText blocklyDropdownText" x="5" y="13" fill="#000">Deck of Cards<tspan> ▾</tspan></text>
              </g>
            </g>
          </g>
        </svg>
        <h3>Command Parameters</h3>
        <p>
          You can also specify Command Parameters as an input to the <strong>Activate Item</strong> action, using the <strong>an Active Item</strong> type selector.
        </p>
        <svg width="570" height="64" viewBox="0 0 570 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(-19,-50)">
            <path class="blocklyPathDark" fill="#4d4d4d" d="M22 61a8 8 0 0 1 8-8h7l6 4h3l6-4h522.448v25H51.5l-6 4h-3l-6-4H22z" />
            <path class="blocklyPath" fill="#606060" d="M21 60a8 8 0 0 1 8-8h7l6 4h3l6-4h522.448v25H50.5l-6 4h-3l-6-4H21z" />
            <path class="blocklyPathLight" stroke="#909090" d="M21.5 60a7.5 7.5 0 0 1 8-7.5H36l6 4h3l6-4h521.948M21.5 76.5V60" />
            <text class="blocklyText" y="13" transform="translate(31 57)">Expect the</text>
            <g class="blocklyEditableText" transform="translate(105.27 57)">
              <rect rx="4" ry="4" height="16" width="168.912" class="blocklyFieldRect blocklyDropdownRect" stroke="#909090" fill="#999" />
              <text class="blocklyText blocklyDropdownText" x="5" y="13">remaining parameters<tspan style={{ fill: '#606060' }}> ▾</tspan></text>
            </g>
            <text class="blocklyText" y="13" transform="translate(279.182 57)">to be</text>
            <g class="blocklyEditableText" transform="translate(316.787 57)">
              <rect rx="4" ry="4" height="16" width="118.397" class="blocklyFieldRect blocklyDropdownRect" stroke="#909090" fill="#999" />
              <text class="blocklyText blocklyDropdownText" x="5" y="13">an Active Item<tspan style={{ fill: '#606060' }}> ▾</tspan></text>
            </g>
            <text class="blocklyText" y="13" transform="translate(440.184 57)">named</text>
            <g class="blocklyEditableText" transform="translate(490.008 57)">
              <rect rx="4" ry="4" height="16" width="78.439" class="blocklyFieldRect" fill="#FFF" />
              <text class="blocklyText" x="5" y="13">item name</text>
            </g>
            <g>
              <path class="blocklyPathDark" fill="#4d4d4d" d="M22 79h15l6 4h3l6-4h50.147v5c0 10-8-8-8 7.5s8-2.5 8 7.5v5H51.5l-6 4h-3l-6-4H30a8 8 0 0 1-8-8z" />
              <path class="blocklyPath" fill="#606060" d="M21 78h15l6 4h3l6-4h50.147v5c0 10-8-8-8 7.5s8-2.5 8 7.5v5H50.5l-6 4h-3l-6-4H29a8 8 0 0 1-8-8z" />
              <path class="blocklyPathLight" stroke="#909090" d="M21.5 78.5H36l6 4h3l6-4h49.647m-4.5 18.8 3.68-2.1m-76.13 5.103A7.5 7.5 0 0 1 21.5 95V78.5" />
              <text class="blocklyText" y="13" transform="translate(31 83)">Activate</text>
              <g>
                <path class="blocklyPathDark" fill="#000" d="M103.147 79h319.27v25h-319.27v-5c0-10-8 8-8-7.5s8 2.5 8-7.5z" />
                <path class="blocklyPath" fill="#000" d="M102.147 78h319.27v25h-319.27v-5c0-10-8 8-8-7.5s8 2.5 8-7.5z" />
                <path class="blocklyPathLight" stroke="#4d4d4d" d="M102.647 78.5h318.27m-318.27 24v-6m-7.36-.5q-1.52-5.5 0-11m7.36 1v-7.5" />
                <text class="blocklyText" y="13" transform="translate(112.147 83)">input from command parameter</text>
                <g class="blocklyEditableText" transform="translate(321.657 83)">
                  <rect rx="4" ry="4" height="16" width="94.76" class="blocklyFieldRect blocklyDropdownRect" stroke="#4d4d4d" fill="#999" />
                  <text class="blocklyText blocklyDropdownText" x="5" y="13">item name<tspan style={{ fill: '#000' }}> ▾</tspan></text>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

Blockly.JSON['player_activate'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'player_activate',
      params
    }
  } else {
    return {
      action: 'player_activate',
      params: {
        entity_id: -1
      }
    }
  }
}

Blockly.Blocks['default_player_activate'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Players current active item.')
    this.setOutput(true, ['active'])
  }
}

Blockly.JSON['default_player_activate'] = (block) => {
  return {
    entity_id: -1
  }
}

Schema.registerAction('player_activate', {
  "if": {
    "properties": {
      "action": {
        "const": "player_activate"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "active",
              "collectible",
              "tier0active",
              "tier1active",
              "tier2active",
              "tier3active",
              "tier4active",
            ],
          },
          "from_param": {
            "type": "string"
          },
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ]
  }
});

/* ****************************************************************************************************************
 * Charges Active Item
 *
 * Charges up the current Active Item. Does not take input parameters.
 ******************************************************************************************************************/
Blockly.Blocks['player_charge'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Charge Active Item')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Fully charge the players current active item.')
  }
}

Blockly.JSON['player_charge'] = (block) => {
  return {
    action: 'player_charge'
  }
}

Schema.registerAction('player_charge', {
  "if": {
    "properties": {
      "action": {
        "const": "player_charge"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Discharges Active Item
 *
 * Disarges the current Active Item. Does not take input parameters.
 ******************************************************************************************************************/
Blockly.Blocks['player_discharge'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Discharge Active Item')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Fully discharge the players current active item.')
  }
}

Blockly.JSON['player_discharge'] = (block) => {
  return {
    action: 'player_discharge'
  }
}

Schema.registerAction('player_discharge', {
  "if": {
    "properties": {
      "action": {
        "const": "player_discharge"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Consume Trinket
 *
 * Consumes the specified Trinket; mimims the Gulp pill or Smelter Active Item. Does not take additional input.
 ******************************************************************************************************************/
Blockly.Blocks['player_consume'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Consume Trinket')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Consume the players current trinket, works like Gulp and Smelter.')
  }
}

Blockly.JSON['player_consume'] = (block) => {
  return {
    action: 'player_consume'
  }
}

Schema.registerAction('player_consume', {
  "if": {
    "properties": {
      "action": {
        "const": "player_consume"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Give Item
 *
 * Gives the player the specified item. Allows any Giveable item to be connected. A default shadow connection is
 * created to default to a random Giveable item being given.
 ******************************************************************************************************************/
Blockly.Blocks['player_give'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_player_give');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck([
        'active',
        'card',
        'collectible',
        'givable',
        'modifier_count',
        'passive',
        'pill',
        'trinket'
      ])
      .appendField('Give')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Gives the specified item to the player. Data must be one of Card, Collectible, Pill, or Trinket.');
  },
  onchange: function () {
    const connection = this.getInput('Input').connection.targetConnection;
    if (connection) {
      this.setEnabled(true);
    } else {
      this.setEnabled(false);
    }
  }
}

Blockly.JSON['player_give'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'player_give',
      params
    }
  } else return;
}

Blockly.Blocks['default_player_give'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Random giveable item.')
    this.setOutput(true, ['givable'])
  }
}

Blockly.JSON['default_player_give'] = (block) => {
  return {
    type: 'random',
    entity_id: -1
  }
}

Schema.registerAction('player_give', {
  "if": {
    "properties": {
      "action": {
        "const": "player_give"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "active",
              "card",
              "collectible",
              "givable",
              "modifier_count",
              "passive",
              "pill",
              "random",
              "spawnable",
              "takable",
              "tier0active",
              "tier1active",
              "tier2active",
              "tier3active",
              "tier4active",
              "tier0passive",
              "tier1passive",
              "tier2passive",
              "tier3passive",
              "tier4passive",
              "trinket"
            ]
          },
          "from_param": {
            "type": "string",
            "minLength": 1,
          },
          "count": {
            "type": "number"
          }
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ]
  }
});

/* ****************************************************************************************************************
 * Set Pocket Item
 ******************************************************************************************************************/
Blockly.Blocks['player_set_pocket'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_player_set_pocket');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['active'])
      .appendField('Set Pocket Item to')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Sets the pocket collectible. If none is specified, the current active item will be moved to the pocket.');
  }
}

Blockly.JSON['player_set_pocket'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  console.log(params);
  if (params) {
    return {
      action: 'player_set_pocket',
      params
    }
  } else return;
}

Blockly.Blocks['default_player_set_pocket'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Players current active item.')
    this.setOutput(true, ['active'])
  }
}

Blockly.JSON['default_player_set_pocket'] = (block) => {
  return {
    entity_id: -1
  }
}

Schema.registerAction('player_set_pocket', {
  "if": {
    "properties": {
      "action": {
        "const": "player_set_pocket"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "active",
              "collectible",
              "tier0active",
              "tier1active",
              "tier2active",
              "tier3active",
              "tier4active",
            ]
          },
          "from_param": {
            "type": "string"
          }
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ]
  }
});

/* ****************************************************************************************************************
 * Drop Pocket Item
 ******************************************************************************************************************/
Blockly.Blocks['player_drop_pocket'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Drop Pocket Item')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Removes the current card/pill/rune located in the players pocket. Can not drop an active item from the pocket slot.')
  }
}

Blockly.JSON['player_drop_pocket'] = (block) => {
  return {
    action: 'player_drop_pocket'
  }
}

Schema.registerAction('player_drop_pocket', {
  "if": {
    "properties": {
      "action": {
        "const": "player_drop_pocket"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Take Item
 ******************************************************************************************************************/
Blockly.Blocks['player_take'] = {
  init: function () {
    this.appendValueInput('Input')
      .setCheck(['Counter', 'takable', 'collectible', 'trinket'])
      .appendField('Take');
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Takes the specified item from the player. Data must be one of Card, Collectible, Pill, or Trinket.');
    this.setHelpUrl('');
  },
  onchange: function () {
    const connection = this.getInput('Input').connection.targetConnection;
    if (connection) {
      this.setEnabled(true);
    } else {
      this.setEnabled(false);
    }
  }
}

Blockly.JSON['player_take'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'player_take',
      params
    }
  } else return;
}

Schema.registerAction('player_take', {
  "if": {
    "properties": {
      "action": {
        "const": "player_take"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "takable",
              "collectible",
              "active",
              "passive",
              "trinket",
            ]
          },
          "from_param": {
            "type": "string"
          }
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Take All
 ******************************************************************************************************************/
Blockly.Blocks['player_take_all'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Take All Items')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Removes all items from the player.')
  }
}

Blockly.JSON['player_take_all'] = (block) => {
  return {
    action: 'player_take_all'
  }
}

Schema.registerAction('player_take_all', {
  "if": {
    "properties": {
      "action": {
        "const": "player_take_all"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Use Pill/Card
 ******************************************************************************************************************/
Blockly.Blocks['player_use'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_player_use');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['counter', 'usable', 'card', 'pill'])
      .appendField('Use')
      .connection
      .connect(shadow.outputConnection);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Use the specified pill or card.')
  }
}

Blockly.JSON['player_use'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  return {
    action: 'player_use',
    params
  }
}

Blockly.Blocks['default_player_use'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Random usable item.')
    this.setOutput(true, ['usable'])
  }
}

Blockly.JSON['default_player_use'] = (block) => {
  return {
    type: 'random',
    entity_id: -1
  }
}

Schema.registerAction('player_use', {
  "if": {
    "properties": {
      "action": {
        "const": "player_use"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "type": {
            "enum": [
              "card",
              "pill",
              "random",
            ]
          },
          "entity_id": {
            "type": "number"
          },
        },
        "required": [
          "type",
          "entity_id"
        ],
        "additionalProperties": false
      }
    }
  }
});
